// Runtime config — values injected via /env-config.js at container startup.
// Localhost defaults used for local development only.
var _env = window.__ENV || {};
export const WEB_API_URL = _env.WEB_API_URL || "http://localhost:3836";
export const WEB_API_MOCK_URL = _env.WEB_API_MOCK_URL || "http://localhost:3836";
export const IDENTITY_API_URL = _env.IDENTITY_API_URL || "http://localhost:5160";
export const UI_APP_URL = _env.UI_APP_URL || "http://localhost:3000/";
export const SIGNALR_API_HUB = _env.SIGNALR_API_HUB || "https://netchex-usertest-webapi-mock.azurewebsites.net";
export const CLIENT_ID = _env.CLIENT_ID || "d7acede2-8847-4caf-9d8a-766cc1b5f4aa";
export const TENANT = _env.TENANT || "devnetchexauth";
export const SignUpSignInPolicy = _env.SignUpSignInPolicy || "B2C_1A_UnknownDevicesMFA_signup_signin";
export const SelectedProductId = 0;
export const SelectedMenuLevel1Id = 0;
export const SelectedMenuLevel2Id = 0;
export const SelectedMenuLevel3Id = 0;
export const LEGACY_LOGIN_URL = _env.LEGACY_LOGIN_URL || "http://localhost";
export const WALKME_SOURCE_URL = _env.WALKME_SOURCE_URL || "https://cdn.walkme.com/users/a6b54476c3584a22896f8e7acff3d177/walkme_a6b54476c3584a22896f8e7acff3d177_https.js";
